<template>
    <div>

        <template v-for="(variant, index) in variants" :key="index">
            <div class="row align-items-center mb-3 pb-3 border-bottom">
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-danger btn-sm" title="Eliminar variante" :data-key="index" @click="deleteVariant(index, variant.product_variant_id)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>

                <div class="col-auto align-self-center">
                    <image-upload :nameInput="'variants[' + index + '][image]'" :src="variant.image" :key="index" />
                    <input type="hidden" :name="'variants[' + index + '][product_variant_id]'" v-model="variant.product_variant_id">
                    <input type="hidden" :name="'variants[' + index + '][product_variant_name]'" v-model="variant.scentSelected">
                </div>

                <div class="col">
                    <div class="form-floating">
                        <select v-model="variant.scent_id"
                            @change="onChangeScent($event, variant)"
                            class="form-select"
                            :class="{ 'is-invalid': getError(index, 'scent_id') }"
                            :name="'variants[' + index + '][scent_id]'"
                            :required="true">
                            <option selected>Selecccionar</option>
                            <option v-for="(scent, item) in listScents" :value="scent.option_values_id" :key="item"> {{ scent.name_scent }} </option>
                        </select>
                        <label for="scent">Aroma</label>
                        <div class="invalid-feedback" v-if="listErrors['variants.'+ index +'.scent_id']">
                            <div class="help-block">&bull; {{ listErrors['variants.'+ index +'.scent_id'][0] }}</div>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="form-floating">
                        <input v-model="variant.codes.code" type="text" :name="'variants[' + index + '][codes][code]'" class="form-control">
                        <label for="code">Code</label>
                    </div>
                </div>

                <div class="col">
                    <div class="form-floating">
                        <input v-model="variant.codes.dun_14" type="text" :name="'variants[' + index + '][codes][dun_14]'" class="form-control">
                        <label for="dun_14">Dun 14</label>
                    </div>
                </div>

                <div class="col">
                    <div class="form-floating">
                        <input v-model="variant.codes.ean_13" type="text" :name="'variants[' + index + '][codes][ean_13]'" class="form-control">
                        <label for="ean_13">Ean 13</label>
                    </div>
                </div>

                <div class="col-auto">
                    <div class="form-check form-switch float-start">
                        <input type="checkbox"
                            v-model="variant.active"
                            class="form-check-input"
                            :name="'variants[' + index + '][active]'"
                            :id="'variant-active-' + index"
                            role="switch"
                            :checked="variant.active == 'on' ? true : false">
                        <label class="form-check-label" :for="'variant-active-' + index">Activo</label>
                    </div>
                </div>
            </div>
        </template>

        <div class="row">
            <div class="d-grid gap-2 mt-4">
                <button type="button" class="btn btn-outline-primary" @click="addVariation">+ Añadir</button>
            </div>
        </div>

    </div>
</template>

<script>
    import ImageUpload from '../ui/ImageUpload.vue'

    export default {
        props: {
            scents: {
                type: Object,
                required: true
            },
            data: {
                type: Array,
                default: null
            },
            errors: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                listScents: null,
                listErrors: null,
                variants: [
                    {
                        'product_variant_id': null,
                        'image': '',
                        'scent_id': '',
                        'codes': {
                            "code": '',
                            "dun_14": '',
                            "ean_13": ''
                        },
                        'scentSelected': null,
                        'active': true
                    }
                ]
            }
        },
        components: {
            ImageUpload
        },
        created() {
            this.variants = this.data
            this.listScents = this.scents
            this.listErrors = this.errors
        },
        methods: {
            addVariation () {
                this.variants.push({
                    'product_variant_id': null,
                    'image': '',
                    'scent_id': '',
                    'codes': { 'code': '','dun_14': '', 'ean_13': '' },
                    'scentSelected': null,
                    'active': true
                })
            },
            deleteVariant (index, id) {
                var opcion = confirm("¿ Deseas eliminar la variante de manera permanente ?");

                if (opcion == true) {
                    window.axios.post('/admin/products/variant-delete',  { 'product_variant_id': id })
                        .then(response => {
                            console.log(response)
                            this.variants = [];
                        })
                        .then(response => {
                            this.variants.response.data.data
                        })
                        .catch(error => {
                            console.log(error.message)
                        })
                }
            },
            onChangeScent(event, variant) {
                variant.scentSelected = event.target.options[event.target.options.selectedIndex].text
            },
            getError (index, field) {
                return this.listErrors['variants.'+ index +'.'+ field] ? true : false;
            }
        }
    }
</script>
